// src/components/Teachers/TeacherDashboard.js
import React from 'react';
import { Link } from 'react-router-dom';

const TeacherDashboard = () => {
  return (
    <div className="teacher-dashboard">
      <h1>Teacher Dashboard</h1>
      <p>Welcome to your teacher portal. Manage your classes, students, and academic tools below.</p>
      
      <div className="teacher-actions">
        <h2>Quick Actions</h2>
        <div className="action-grid">
          <Link to="/manage-students" className="action-card">
            <h3>👨‍🎓 Manage Students</h3>
            <p>View and manage your student roster</p>
          </Link>
          
          <Link to="/groups/" className="action-card">
            <h3>👥 Manage Groups</h3>
            <p>Create and organize student groups</p>
          </Link>
          
          <Link to="/schedules" className="action-card">
            <h3>📅 Manage Schedules</h3>
            <p>Set up and modify class schedules</p>
          </Link>
          
          <Link to="/attendance" className="action-card">
            <h3>✅ Take Attendance</h3>
            <p>Record daily student attendance</p>
          </Link>
          
          <Link to="/reports/v2" className="action-card">
            <h3>📈 Reports & Analytics</h3>
            <p>View attendance reports with advanced filtering</p>
          </Link>
        </div>
      </div>
      
      <style>{`
        .teacher-dashboard {
          max-width: 900px;
          margin: 30px auto;
          padding: 20px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        
        .action-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }
        
        .action-card {
          display: block;
          padding: 24px;
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          text-decoration: none;
          color: inherit;
          transition: all 0.3s ease;
          background: #ffffff;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        
        .action-card:hover {
          border-color: #1976d2;
          box-shadow: 0 4px 12px rgba(25,118,210,0.15);
          transform: translateY(-3px);
        }
        
        .action-card h3 {
          margin: 0 0 12px 0;
          color: #1976d2;
          font-size: 1.2rem;
          font-weight: 600;
        }
        
        .action-card p {
          margin: 0;
          color: #666;
          line-height: 1.5;
        }
        
        .teacher-actions h2 {
          color: #333;
          margin-bottom: 10px;
          font-size: 1.5rem;
        }
        
        h1 {
          color: #1976d2;
          margin-bottom: 10px;
        }
        
        p {
          color: #666;
          margin-bottom: 30px;
          font-size: 1.1rem;
        }
      `}</style>
    </div>
  );
};

export default TeacherDashboard;
